<template>
    <div :class="classes">
        <fade-transition>
            <button class="upperTop"
                    type="button"
                    @click="onClick"
            >
                <svg version="1.1" id="icon-arrow-right-white" xmlns="http://www.w3.org/2000/svg"
                     xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="9.117px" height="18.001px"
                     viewBox="0.883 0 9.117 18.001" enable-background="new 0.883 0 9.117 18.001" xml:space="preserve">
						<polygon fill="#FFFFFF" points="0.883,17.318 8.633,9 0.883,0.682 1.615,0 10,9 1.615,18.001 "/>
					</svg>
            </button>
        </fade-transition>
    </div>
</template>

<script>
    import _throttle from 'lodash/throttle'

    export default {
        data() {
            return {
                show: false,
            }
        },
        mounted() {
            window.addEventListener('scroll', _throttle(this.onScroll, 10))
        },
        computed: {
            classes() {
                return [
                    'upperTopWrapper',
                    {'upperTopWrapper-visible': this.show}
                ]
            }
        },
        methods: {
            onScroll() {
                this.show = window.pageYOffset > 250
            },
            onClick() {
                this.$scrollTo('body')
            },
        }
    }
</script>
